module.exports = __webpack_public_path__ + "img/clipboard-plus-outline.27c05be2.svg";